<template>
  <div class="accordion-details">
    <div class="accordion-details__header" @click="toggle">
      <Text pattern="body1" :weight="600">
        {{ $t("Details") }}
      </Text>
      <span class="arrow" :class="{ open: isOpen }">
        <BaseSvgIcon name="arrow-simple" class="accordion-details_arrow-icon" />
      </span>
    </div>
    <BaseAccordionBody :show="isOpen" :transition="150">
      <div :class="['accordion-details__content']">
        <div
          v-for="(detail, index) in computedDetails"
          :key="'left-' + index"
          class="accordion-details__item"
        >
          <Text
            class="accordion-details__item_title"
            pattern="body2"
            color="#787878"
            :height="150"
            :weight="500"
          >
            {{ detail.label }}
          </Text>
          <div class="accordion-details__item_value">
            <Text pattern="body2" :weight="500">
              {{ fetchValue(detail) }}
            </Text>
            <!--<Text
                v-if="detail.subField"
                color="#787878"
                pattern="body2"
                :weight="500"
              >
                {{ fetchValue(detail.subField, detail.format) }}
              </Text> -->
          </div>
        </div>
      </div>
    </BaseAccordionBody>
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
import BaseSvgIcon from "@/shared/ui/BaseSvgIcon/BaseSvgIcon.vue";
import { BaseAccordionBody } from "@/shared/ui";
import "@/assets/icons/SVG/arrow-simple.svg";
import { stringInject } from "@/shared/utils/format/string";
export default {
  name: "AccordionDetails",
  components: {
    Text,
    BaseSvgIcon,
    BaseAccordionBody,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    details: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: true,
    };
  },
  computed: {
    computedDetails() {
      this.details.forEach((detail) => {
        detail.value = this.fetchValue(detail);
      });

      return this.details.filter((detail) => !!detail.value);
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    fetchValue(detail) {
      if (detail?.calculate) {
        return detail.calculate(this.item);
      }

      const getValue = (obj, prop) => {
        if (!obj) {
          return "";
        }

        const index = (prop || "").indexOf(".");
        if (index > -1) {
          return getValue(
            obj[prop.substring(0, index)],
            prop.substr(index + 1),
          );
        }

        return obj[prop] || "";
      };

      const value = getValue(this.item, detail.field);

      if (!value) {
        return "";
      }

      return detail.format ? stringInject(detail.format, [value]) : value;
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-details {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  &__content {
    margin-top: 24px;
    border-top: 1px solid #1a1a1a;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-top: 24px;
    gap: 24px;
  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
  }

  &__item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;

    &_title {
      flex: 2;
    }

    &_value {
      flex: 3;
    }
  }

  .icon {
    width: 16px;
    height: 16px;
  }

  &_arrow-icon {
    width: 24px;
    height: 24px;
  }
}
.arrow {
  transition: transform 0.3s ease;
  margin: 0 16px;
}

.open {
  transform: rotate(180deg);
}

@media (max-width: 768px) {
  .accordion-details {
    &__content {
      grid-template-columns: 1fr;
    }

    &__item_value {
      flex: 2;
    }
  }
}
</style>
